<template lang="pug">
  section
    h1 介绍
    h2 写在前面
    p 学到老，才能活到老。这是我为了提升自己基于Vue搭建的一个UI框架，目前轮子较少，日后会继续完善。
    h1 项目特点
    ul
      li 单向数据流
      li
        | 使用了
        strong.code Vue
        | 中许多技术，例如组件递归引用、内容分发(slot)、指令、mixin等
      li
        | 组件的样式、色彩搭配参考较为成熟的
        strong.code UI
        | 框架(
        strong.code iview
        | ,
        strong.code material-ui
        | 等)
      li 单元测试，持续集成
</template>
<script>
export default {

}
</script>
<style lang="scss" scoped>
p {
  margin: 16px 0;
}
ul {
  list-style: disc;
}
li {
  margin: 16px 0;
}
.code {
  background: #eee;
}
</style>
